import { publicAxios } from "../../../config/apiConfig";
import {
  GET_ALL_CATEGORY_SUCCESS,
  GET_ALL_CATEGORY_REQUEST,
  GET_ALL_CATEGORY_FAILURE,
  GET_ALL_SUBCATEGORY_SUCCESS,
  GET_ALL_SUBCATEGORY_FAILURE,
  GET_ALL_SUBCATEGORY_REQUEST,
  GET_ALL_PRODUCTCATEGORY_REQUEST,
  GET_ALL_PRODUCTCATEGORY_SUCCESS,
  GET_ALL_PRODUCTCATEGORY_FAILURE,
} from "./ActionType";

export const getAllCategory = () => async (dispatch) => {
  dispatch({ type: GET_ALL_CATEGORY_REQUEST });
  try {
    const { data } = await publicAxios.get(`categories`);
    dispatch({ type: GET_ALL_CATEGORY_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: GET_ALL_CATEGORY_FAILURE, payload: error.message });
  }
};

export const getAllsubCategoryByCategory = (categoryId) => async (dispatch) => {
  dispatch({ type: GET_ALL_SUBCATEGORY_REQUEST });
  try {
    const { data } = await publicAxios.get(`subCategories/category/${categoryId}`);
    dispatch({ type: GET_ALL_SUBCATEGORY_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: GET_ALL_SUBCATEGORY_FAILURE, payload: error.message });
  }
};

export const getAllProductCategoryBySubCategory = (subCategoryId) => async (dispatch) => {
  dispatch({ type: GET_ALL_PRODUCTCATEGORY_REQUEST });
  try {
    const { data } = await publicAxios.get(`productCategories/subCategory/${subCategoryId}`);
    dispatch({ type: GET_ALL_PRODUCTCATEGORY_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: GET_ALL_PRODUCTCATEGORY_FAILURE, payload: error.message });
  }
};



